export default "__VITE_ASSET__B00SQu$o__"